// extracted by mini-css-extract-plugin
export default {"submitButton":"LoginForm_submitButton__SZeMB"};